import { render, staticRenderFns } from "./zp-base-part.vue?vue&type=template&id=5c5d56fa"
import script from "./zp-base-part.vue?vue&type=script&lang=js"
export * from "./zp-base-part.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports